import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EndpointStatusDomainsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type EndpointStatusDomainsQuery = { __typename?: 'Query', domains?: { __typename?: 'DomainList', items: Array<{ __typename?: 'Domain', id: number, name: string } | null> } | null };

export type EndpointStatusExtensionQueryVariables = Types.Exact<{
  filter: Types.Scalars['String']['input'];
}>;


export type EndpointStatusExtensionQuery = { __typename?: 'Query', users?: { __typename?: 'UserList', items: Array<{ __typename?: 'User', number?: { __typename?: 'Number', e164?: any | null, domain: { __typename?: 'Domain', id: number, name: string } } | null } | null> } | null };


export const EndpointStatusDomainsDocument = gql`
    query EndpointStatusDomains {
  domains {
    items {
      id
      name
    }
  }
}
    `;

/**
 * __useEndpointStatusDomainsQuery__
 *
 * To run a query within a React component, call `useEndpointStatusDomainsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEndpointStatusDomainsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEndpointStatusDomainsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEndpointStatusDomainsQuery(baseOptions?: Apollo.QueryHookOptions<EndpointStatusDomainsQuery, EndpointStatusDomainsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EndpointStatusDomainsQuery, EndpointStatusDomainsQueryVariables>(EndpointStatusDomainsDocument, options);
      }
export function useEndpointStatusDomainsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EndpointStatusDomainsQuery, EndpointStatusDomainsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EndpointStatusDomainsQuery, EndpointStatusDomainsQueryVariables>(EndpointStatusDomainsDocument, options);
        }
export function useEndpointStatusDomainsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EndpointStatusDomainsQuery, EndpointStatusDomainsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EndpointStatusDomainsQuery, EndpointStatusDomainsQueryVariables>(EndpointStatusDomainsDocument, options);
        }
export type EndpointStatusDomainsQueryHookResult = ReturnType<typeof useEndpointStatusDomainsQuery>;
export type EndpointStatusDomainsLazyQueryHookResult = ReturnType<typeof useEndpointStatusDomainsLazyQuery>;
export type EndpointStatusDomainsSuspenseQueryHookResult = ReturnType<typeof useEndpointStatusDomainsSuspenseQuery>;
export type EndpointStatusDomainsQueryResult = Apollo.QueryResult<EndpointStatusDomainsQuery, EndpointStatusDomainsQueryVariables>;
export const EndpointStatusExtensionDocument = gql`
    query EndpointStatusExtension($filter: String!) {
  users(filter: $filter) {
    items {
      number {
        e164
        domain {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useEndpointStatusExtensionQuery__
 *
 * To run a query within a React component, call `useEndpointStatusExtensionQuery` and pass it any options that fit your needs.
 * When your component renders, `useEndpointStatusExtensionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEndpointStatusExtensionQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEndpointStatusExtensionQuery(baseOptions: Apollo.QueryHookOptions<EndpointStatusExtensionQuery, EndpointStatusExtensionQueryVariables> & ({ variables: EndpointStatusExtensionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EndpointStatusExtensionQuery, EndpointStatusExtensionQueryVariables>(EndpointStatusExtensionDocument, options);
      }
export function useEndpointStatusExtensionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EndpointStatusExtensionQuery, EndpointStatusExtensionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EndpointStatusExtensionQuery, EndpointStatusExtensionQueryVariables>(EndpointStatusExtensionDocument, options);
        }
export function useEndpointStatusExtensionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EndpointStatusExtensionQuery, EndpointStatusExtensionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EndpointStatusExtensionQuery, EndpointStatusExtensionQueryVariables>(EndpointStatusExtensionDocument, options);
        }
export type EndpointStatusExtensionQueryHookResult = ReturnType<typeof useEndpointStatusExtensionQuery>;
export type EndpointStatusExtensionLazyQueryHookResult = ReturnType<typeof useEndpointStatusExtensionLazyQuery>;
export type EndpointStatusExtensionSuspenseQueryHookResult = ReturnType<typeof useEndpointStatusExtensionSuspenseQuery>;
export type EndpointStatusExtensionQueryResult = Apollo.QueryResult<EndpointStatusExtensionQuery, EndpointStatusExtensionQueryVariables>;